export default __webpack_public_path__ + "static/media/ic_uni_arbitrum.a1fa0b7f.svg";